module.exports = __webpack_public_path__ + "static/media/Eagle Face004_4c.9643bf62.svg";